import * as UserApi from '@/api/Info'

export default function useChat() {
  const signIn = async (payload) => {
    const res = await UserApi.signIn(payload)
    return res
  }
  const getUserInfo = async (payload) => {
    const res = await UserApi.getUserInfo(payload)
    return res
  }
  const signOut = async (payload) => {
    const res = await UserApi.signOut(payload)
    return res
  }
  const userContact = async (payload) => {
    const res = await UserApi.userContact(payload)
    return res
  }

  return {
    signIn,
    getUserInfo,
    signOut,
    userContact,
  }
}
